import clsx from 'clsx';
import { replaceNewLineToTag } from '@/utils';
import { PopupType, PopupIconType } from '../types';
import Button from '@/components/atoms/button';
import { ERROR_LIMIT_COUNT } from '@/consts';

interface IProps {
  msg: string;
  errorMsg?: string;
  okCaption?: boolean;
  cancelCaption?: boolean;
  popupType: PopupType;
  iconType?: PopupIconType;
  isIcon?: boolean;
  isAlert?: boolean;
  onOk: () => void;
  onClose: () => void;
}

const AlertDialog = ({
  msg,
  errorMsg,
  okCaption,
  cancelCaption,
  isIcon,
  isAlert,
  iconType,
  onOk,
  onClose,
}: IProps): JSX.Element => (
  <div className="modal-overlay" id="modalOverlay">
    <div className="modal-contents">
      <div className="modal-header">
        <button className="close" onClick={onClose}>
          <i className="bi bi-x-lg"></i>
        </button>
      </div>
      <div className="modal-body">
        {iconType === PopupIconType.EXCLAMATION && isIcon && (
          <div className="top">
            <div className={clsx('icon-area')}>
              <img src="img/modal-alert-icon.png" alt="icon" />
            </div>
          </div>
        )}
        {iconType === PopupIconType.CHECK && isIcon && (
          <div className="top">
            <div className={clsx('icon-area')}>
              <img src="img/modal-cnf-icon.png" alt="icon" />
            </div>
          </div>
        )}
        <div className="mid">{errorMsg && <p className="body-n-n">{`${errorMsg} / ${ERROR_LIMIT_COUNT}회`}</p>}</div>
        <div className="bot">
          <p className="body-l-n fw-b" dangerouslySetInnerHTML={{ __html: replaceNewLineToTag(msg) }} />
        </div>
      </div>
      <div className="modal-footer">
        {isAlert ? (
          <div className="two-button">
            {cancelCaption && (
              <Button caption="아니오" className="cancel-button alert_modal_cancel_button l-button" onClick={onClose} />
            )}
            {okCaption && <Button caption="예" className="modal_solid l-button" onClick={onOk} />}
          </div>
        ) : (
          <div className="one-button">
            <Button caption="확인" className="modal_solid l-button" onClick={onOk} />
          </div>
        )}
      </div>
    </div>
  </div>
);

export default AlertDialog;

{
  /* <div class="btn-area-trxn-snd send_check_btn" style="display: flex;">
  <button class="cancel-button l-button">취소</button>
  <button class="next-button l-button" disabled="">다음</button
  ></div> */
}
